import { StyleBannerWrapper, StyleHalfBanner } from './style'
import AppointmentBanner from '@commons/cards/appointmentBanner'
import InstantImg from '@assets/images/instant.png'
import RequestImg from '@assets/images/request.png'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
const Banner = () => {
  const navigate = useNavigate()
  const { data: appointmentConsultDashboard } = useSelector(
    (state: any) => state.appointmentConsultDashboard,
  )
  return (
    <StyleBannerWrapper>
      <StyleHalfBanner>
        <AppointmentBanner
          title="Instant Consultation Request"
          bg="primary300"
          Img={InstantImg}
          description={`Stay connected — accept instant requests and provide 
          real-time medical guidance`}
          btnTitle={`${appointmentConsultDashboard?.totalInstantRequest} New Requests`}
          onClick={() => {
            navigate('/doctor/appointments/instants')
          }}
        />
      </StyleHalfBanner>
      <StyleHalfBanner>
        <AppointmentBanner
          title="Appointment Booking Request"
          bg="yellow200"
          Img={RequestImg}
          description={`Manage patient bookings and stay in control of your consultation schedule.`}
          btnTitle={`${appointmentConsultDashboard?.totalScheduleRequest} New Requests`}
          onClick={() => {
            navigate('/doctor/appointments/requests')
          }}
        />
      </StyleHalfBanner>
    </StyleBannerWrapper>
  )
}

export default Banner
